<template>
    <div class="checkout_container"
        :class="{ 'isModoTap': isModotap(), 'noservicetax': !hasServiceTax(), 'gom_layout': isGomLayout() }">
        <input type="number" autocomplete="off" id="tapInputCheckout" ref="tapInputCheckout" v-model="comandaNumber">

        <div class="header" :class="{ 'gom_layout': isGomLayout() }">
            <CircleButton v-if="!isGomLayout()" class="CircleButton" big="true" :icon="arrow_back_white"
                @circleBtnClick="navigateToHome" black="true"></CircleButton>
            <span v-text="isGomLayout() ? getString('confira_seu_pedido') : getString('carrinho')"></span>
        </div>

        <div class="cart_itens" v-if="!isGomLayout()">
            <template v-if="comandasAgregadas.length <= 1">
                <CheckoutItem :cart="cart" @reloadPrice="refreshSubgroupDiscounts" :unavailableProducts="unavailableProducts">
                </CheckoutItem>
            </template>
            <template v-else>
                <div class="comanda-container" v-for="(com, key) in comandasAgregadas" :key="key">
                    <span class="numero_comanda_agregada"
                        v-text="getString('comanda') + ` ${com.saleDescription}`"></span>
                    <span v-if="key != 0" class="remover_comanda_agregada" v-text="getString('remover')"
                        @click="splitComanda(com.saleDescription)"></span>
                    <CheckoutItem :cart="com.items" :unavailableProducts="unavailableProducts"
                        @reloadPrice="refreshSubgroupDiscounts"></CheckoutItem>
                </div>
            </template>
        </div>

        <div class="cart_itens gom_layout" v-else>
            <div class="cart_itens_container gom_layout">
                <template v-if="comandasAgregadas.length <= 1">
                    <div class="comanda-container">
                        <CheckoutItemGom :cart="cart" :unavailableProducts="unavailableProducts"
                            @reloadPrice="refreshSubgroupDiscounts"></CheckoutItemGom>
                    </div>
                </template>
                <template v-else>
                    <div class="comanda-container">
                        <div class="comanda-container" v-for="(com, key) in comandasAgregadas" :key="key">
                            <span class="numero_comanda_agregada"
                                v-text="getString('comanda') + ` ${com.saleDescription}`"></span>
                            <span v-if="key != 0" class="remover_comanda_agregada" v-text="getString('remover')"
                                @click="splitComanda(com.saleDescription)"></span>
                            <CheckoutItemGom :cart="com.items" @reloadPrice="refreshSubgroupDiscounts"></CheckoutItemGom>
                        </div>
                    </div>
                </template>
                <div class="cart_itens_footer">
                    <div class="footer_left_gom">
                        <!-- <div class="receipt-line subtotal-line" v-if="totalSubgroupDiscount > 0">
                            <span class="receipt-label">{{ getString('subtotal_dois_pontos') }}</span>
                            <span class="receipt-value">{{ subtotal }}</span>
                        </div>
                        <div class="receipt-line discount-line" v-if="totalSubgroupDiscount > 0">
                            <span class="receipt-label">{{ getString('desconto_dois_pontos') }}</span>
                            <span class="receipt-value discount-value">- {{ formatMoney(totalSubgroupDiscount) }}</span>
                        </div> -->
                        <div class="receipt-line total-line">
                            <span class="receipt-label total-label">{{ getString('total_dois_pontos') }}</span>
                            <span class="receipt-value total-value" v-text="total"></span>
                        </div>
                    </div>
                    <div class="tax-service-gom" v-if="isModotap() || isBalancaMode()"
                        :class="{ 'noservicetax': !hasServiceTax() }">
                        <div class="tax-service-buttons"
                            v-if="(!useFixedServiceTax() || (useFixedServiceTax() && automaticServiceTax && serviceTaxEditedBkp > 0))">
                            <span v-if="hasServiceTax() && !isBalancaMode()"
                                :class="{ 'tax-service-disabled': serviceTaxDisabled }"
                                v-text="buildTextServiceTax()" />

                            <div class="control-buttons" v-if="hasServiceTax() && !isBalancaMode()">
                                <!-- <CircleButton v-if="!serviceTaxDisabled" :big="false" :icon="delete_white" @circleBtnClick="removeServiceTax()"></CircleButton>
                                <CircleButton v-else :big="false" :icon="edit_white" @circleBtnClick="viewServiceTax()"></CircleButton> -->

                                <CircleButton v-if="!serviceTaxDisabled && serviceTaxApplied" :big="false"
                                    :icon="delete_white" @circleBtnClick="removeServiceTax()"></CircleButton>
                                <CircleButton
                                    v-if="!serviceTaxDisabled && removTXServTap && !useFixedServiceTax() && serviceTaxApplied"
                                    :big="false" :icon="edit_white" @circleBtnClick="viewServiceTax()"></CircleButton>
                                <CircleButton v-if="serviceTaxDisabled" :big="false" :icon="plus_white"
                                    @circleBtnClick="viewServiceTax()"></CircleButton>
                            </div>
                        </div>
                        <div class="tap-buttons">
                            <DefaultButton v-if="isBalancaMode()" class="bottom"
                                :text="getString('adicionar_nova_pesagem')"
                                @defaultBtnClick="navigateToBalancaScreen()"></DefaultButton>
                            <DefaultButton v-else class="bottom" :text="getString('adicionar_mais_comandas')"
                                @defaultBtnClick="addComandasParaPagamento()"></DefaultButton>
                        </div>
                    </div>
                </div>
            </div>
            <div class="to_payment" :class="{'center': !addprodTAP || !isModotap() }">
                <DefaultButton :text="getString('realizar_pagamento')" :btnCart="exibeContinuarComprando"
                    @defaultBtnClick="navigateToPayment" :disabled="waitToContinue"></DefaultButton>
                <DefaultButton class="bottom" :text="getString('adicionar_produto')"
                    @defaultBtnClick="openAddProductModal()" v-if="isModotap() && addprodTAP"></DefaultButton>
            </div>
        </div>

        <div class="overlay" v-show="showInsertComanda" @click="closeComandaInputs"></div>
        <div class="overlay" v-show="showAlterTax" @click="closeAlterTaxInputs"></div>

        <div :class="{ 'hidden': hidden }" class="add-product-button" v-if="!isGomLayout()">
            <DefaultButton class="bottom" v-if="isModotap() && addprodTAP" :text="getString('adicionar_produto')"
                @defaultBtnClick="openAddProductModal()"></DefaultButton>
        </div>
        <div class="tax-service" v-if="isModotap() && !isGomLayout()" :class="{ 'noservicetax': !hasServiceTax() }">
            <template
                v-if="(!useFixedServiceTax() || (useFixedServiceTax() && automaticServiceTax && serviceTaxEditedBkp > 0))">
                <div style="position: relative;" v-if="hasServiceTax() && !isBalancaMode()"
                    :class="{ 'tax-service-disabled': serviceTaxDisabled }">
                    <span style="margin: 0; position: absolute;  top: 50%; transform: translate(0, -50%);"
                        v-text="buildTextServiceTax()" />
                </div>
                <div class="tax-service-buttons" v-if="hasServiceTax() && !isBalancaMode()">
                    <CircleButton v-if="!serviceTaxDisabled" big="false" :icon="delete_white"
                        @circleBtnClick="removeServiceTax()"></CircleButton>
                    <CircleButton
                        v-if="!serviceTaxDisabled && removTXServTap && !useFixedServiceTax() && serviceTaxApplied"
                        big="false" :icon="edit_white" @circleBtnClick="viewServiceTax()"></CircleButton>
                    <CircleButton v-if="serviceTaxDisabled" big="false" :icon="plus_white"
                        @circleBtnClick="viewServiceTax()"></CircleButton>
                </div>
            </template>
            <template v-else>
                <div style="display: none;"></div>
                <div style="display: none;"></div>
            </template>
            <div class="tap-buttons">
                <DefaultButton v-if="isBalancaMode()" class="bottom" :text="getString('adicionar_nova_pesagem')"
                    @defaultBtnClick="navigateToBalancaScreen()"></DefaultButton>
                <DefaultButton v-else class="bottom" :text="getString('adicionar_mais_comandas')"
                    @defaultBtnClick="addComandasParaPagamento()"></DefaultButton>
            </div>
        </div>

        <div class="suggestions-bar-container">
            <SuggestionsBar
                v-show="showSuggestions"
                :productCode="suggestProductCode"
                :groupCode="suggestGroupCode"
                :indexCart="lastIndexNotSuggested"
                @handleSuggestion="handleSuggestion"
                @closeSuggestions="closeSuggestions"
                @navigateToGroup="navigateToGroup">
            </SuggestionsBar>
        </div>

        <div class="footer-checkout" v-if="!isGomLayout()">
            <div class="footer_left">
                <div class="footer_text">

                    <div class="total_container">
                        <span id="total_text">{{ getString('total_dois_pontos') }}</span>
                        <span id="total_price" v-text="total"></span>
                    </div>
                </div>
                <CircleButton v-if="!isModotap() || isBalancaMode()" big="true" :icon="delete_white"
                    @circleBtnClick="clearCart"></CircleButton>
            </div>
            <DefaultButton :text="getString('continuar_comprando')" :btnCart="exibeContinuarComprando"
                @defaultBtnClick="navigateToHome" v-if="exibeContinuarComprando"></DefaultButton>
            <DefaultButton :text="getString('realizar_pagamento')" :btnCart="exibeContinuarComprando"
                @defaultBtnClick="navigateToPayment" :disabled="waitToContinue"></DefaultButton>
        </div>
        <div class="footer-checkout gom_layout" v-else>
            <DefaultButton v-if="!isModotap()" :text="getString('voltar_cardapio')" @defaultBtnClick="backToHome()"
                layoutGom="true" outlined="true"></DefaultButton>
            <DefaultButton :text="!isModotap() ? getString('cancelar_pedido') : getString('cancelar')"
                @defaultBtnClick="clearCart()" layoutGom="true" outlined="true"></DefaultButton>
        </div>
        <div class="comandaInputContainer" v-show="showInsertComanda">
            <h1 v-if="!useBarcodeComand">{{ getString('digite_numero_comanda_ou_faca_leitura') }}</h1>
            <div class="barcode-container" v-else>
                <img :src="barcodeImage">
                <h2 v-text="getString('faca_leitura_do_codigo_de_barras')"></h2>
            </div>
            <div id="comandaNumber" class="div-input-android" ref="comandaNumberCheckoutDiv"></div>

            <AndroidKeyboard id="android-keyboard" :inputElement="inputElement" :layout="layout" :accept="acceptAndroid" v-if="!useBarcodeComand"
                :bigNumeric="true">
            </AndroidKeyboard>
        </div>

        <div class="comandaInputContainer alterTaxContainer" v-show="showAlterTax">
            <h1>{{ getString('digite_valor_deseja_pagar') }}</h1>
            <!-- <div v-if="isAndroidMode()" id="alterTax" class="div-input-android"></div>
        <input v-else type="text" autocomplete="off" id="alterTax" v-model="serviceTaxEdited" data-layout="numeric" @focus="show"> -->
            <div class="money-container">
                <span class="money-symbol">R$</span>
                <div id="alterTax" class="div-input-android"></div>
            </div>

            <AndroidKeyboard id="android-keyboard" :inputElement="inputElement" :layout="layout" :bigNumeric="true"
                :onInput="applyMoneyRules">
            </AndroidKeyboard>

            <DefaultButton class="confirm-button" :text="getString('confirmar')" :green="true"
                @defaultBtnClick="acceptAndroid">
            </DefaultButton>
        </div>

        <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide"
            :next="accept" :accept="accept" :input="input" />

        <!-- <AndroidKeyboard id="android-keyboard" v-if="androidVisible"
        :inputElement="inputElement"
        :layout="layout"
        :accept="acceptAndroid">
    </AndroidKeyboard> -->
        <Transition name="bounce">
            <AddProductModal v-if="showAddProductModal" :pendingComandaNumber="pendingComandaNumber" @closeAddProductModal="closeAddProductModal"></AddProductModal>
        </Transition>
        <div class="overlay" v-show="showAddProductModal"></div>
    </div>
</template>

<script>
import Vue from 'vue'
import DefaultButton from '@/components/DefaultButton'
import CircleButton from '@/components/CircleButton'
import CheckoutItem from '@/components/CheckoutItem'
import CheckoutItemGom from '@/components/CheckoutItemGom'
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import ProductController from '@/assets/controllers/ProductController'
import SaleController from '@/assets/controllers/SaleController'
import PersonalCreditModal from '@/components/PersonalCreditModal'
import ConfirmConsumerModal from '@/components/ConfirmConsumerModal'
import RfidController from '@/assets/controllers/RfidController'
import VueTouchKeyboard from 'vue-touch-keyboard'
import LocaleController from '@/assets/controllers/LocaleController'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import AddProductModal from '../components/AddProductModal.vue'
import SuggestionsBar from '@/components/SuggestionsComponents/SuggestionsBar'
import SuggestionsController from '@/assets/controllers/SuggestionsController'
import eventModule from '@/assets/libs/eventModule'
import SubgroupDiscountController from '@/assets/controllers/SubgroupDiscountController'
Vue.use(VueTouchKeyboard)

export default {
    name: 'Checkout',
    components: {
        CircleButton,
        DefaultButton,
        CheckoutItem,
        PersonalCreditModal,
        ConfirmConsumerModal,
        CheckoutItemGom,
        AndroidKeyboard,
        AddProductModal,
        SuggestionsBar
    },
    data () {
        return {
            cart: CartController.getCart(),
            arrow_back_white: require('../../static/icons/arrow_back_white.svg'),
            delete_white: require('../../static/icons/delete_white.svg'),
            layout: 'numeric',
            comandaNumber: '',
            androidBarCodeComanda: '',
            visible: false,
            showInsertComanda: false,
            showAlterTax: false,
            edit_white: require('../../static/icons/edit_white.svg'),
            plus_white: require('../../static/icons/plus_white.svg'),
            comandasAgregadas: CartController.getComandasAgregadas(),
            options: {
                useKbEvents: true,
                preventClickEvent: false
            },
            serviceTaxEdited: 0,
            serviceTaxEditedBkp: 0,
            total: 0,
            subtotal: '',
            serviceTaxDisabled: true,
            controlsEnabled: true,
            totalSubgroupDiscount: CartController.getTotalSubgroupDiscount(),
            exibeContinuarComprando: false,
            androidVisible: false,
            inputElement: null,
            gertecBarcodeInterval: null,
            removTXServTap: Util.getLocalConfigs('removTXServTap'),
            automaticServiceTax: Util.getLocalConfigs('automaticServiceTax'),
            showAddProductModal: false,
            hidden: true,
            unavailableProducts: {},
            addprodTAP: Util.addprodTAP(),
            serviceTaxApplied: false,
            hybridMode: Util.isHybridMode(),
            useBarcodeComand: Util.getLocalConfigs('useBarcodeComand'),
            barcodeImage: require('../../static/icons/ic-codigo-barras.png'),
            idSolDigCons: Util.getLocalConfigs('idSolDigCons'),
            ignoreQrCodeSk: Util.getLocalConfigs('ignoreQrCode') || false,
            showSuggestions: false,
            suggestProductCode: null,
            suggestGroupCode: null,
            lastIndexNotSuggested: null,
            waitToContinue: false,
            pendingComandaNumber: ''
        }
    },
    created () {
        eventModule.$on('reloadPrice', this.refreshSubgroupDiscounts)
    },
    mounted () {
        SuggestionsController.resetSuggestionsController()

        // Não remover esse refresh do getCart. Atualiza o carrinho depois de restaurar a tabela de preços
        CartController.recalculateCart()
        this.cart = CartController.getCart()

        const lastIndexNotSuggested = this.cart.findLastIndex(item => !item.productSuggested)
        if (lastIndexNotSuggested !== -1) {
            // Avoid reopening suggestion modal automatically when user returns from checkout.
            SuggestionsController.markSuggestionsShown(lastIndexNotSuggested)
        }

        this.unavailableProducts = CartController.getUnavailableProducts()

        const routeParams = this.$route.params || {}
        const hasPendingComanda = routeParams.openAddProductModal === true && routeParams.pendingComandaNumber !== ''

        if (this.isModotap() && !hasPendingComanda) {
            this.serviceTaxEdited = this.formatMoney(CartController.getMainComandaAgregada().serviceTax)
            this.serviceTaxEditedBkp = CartController.getMainComandaAgregada().serviceTax
            this.serviceTaxApplied = CartController.getMainComandaAgregada().serviceTaxApplied
            if (this.automaticServiceTax || this.serviceTaxApplied) {
                this.serviceTaxDisabled = false
                this.confirmServiceTax()
            }
        }

        this.fillProductsBoxes()
        this.total = this.calculateTotalPrice()

        this.refreshSubgroupDiscounts()

        this.exibeContinuarComprando = !this.isModotap() && !this.isBalancaMode() && Util.getLocalConfigs('exibeContinuarComprando')

        if (Util.isAndroidMode() && Util.isGertecSk210() && Util.isTapMode()) {
            setTimeout(() => {
                window.GertecBarcodeReader.startDecode(this.ignoreQrCodeSk)
            }, 1000)

            this.gertecBarcodeInterval = setInterval(() => {
                let readedCode = window.GertecBarcodeReader.getReadedCode()
                if (readedCode) {
                    this.comandaNumber = readedCode
                    this.accept()
                }
            }, 1000)
        } else if (Util.isAndroidMode()) {
            document.addEventListener('keypress', this.handleAndroidKeypress)
        } else {
            setTimeout(() => {
                if (this.$refs.tapInputCheckout) {
                    this.$refs.tapInputCheckout.addEventListener('keypress', this.handleKeypress)
                    this.barcodeInterval = setInterval(() => {
                        if (this.$refs.tapInputCheckout) {
                            this.$refs.tapInputCheckout.focus()
                        }
                    }, 500)
                }
            }, 100)
        }
        setTimeout(() => {
            this.hidden = false
        }, 500)
        RfidController.listenForRfid(this.handleCardSerialNumber)

        // Check route params FIRST — a pending comanda arrives with an empty cart intentionally.
        // Redirecting before reading these params would send the user back to Home incorrectly.

        if (hasPendingComanda) {
            this.pendingComandaNumber = routeParams.pendingComandaNumber
            setTimeout(() => {
                this.openAddProductModal(true)
            }, 300)
        } else if (this.cart.length === 0) {
            // Only redirect to Home when it's a genuine empty-cart situation (not a pending comanda)
            Util.showInfoModal(this.getString('erro_comanda_vazia'))
            this.$router.push('Home')
        }

        this.$forceUpdate()
        setTimeout(() => { this.openSuggestions() }, 500)
    },
    beforeDestroy () {
        eventModule.$off('reloadPrice', this.refreshSubgroupDiscounts)
        RfidController.stopListeningForRfid()

        if (Util.isAndroidMode() && Util.isGertecSk210() && Util.isTapMode()) {
            clearInterval(this.gertecBarcodeInterval)
            window.GertecBarcodeReader.stopDecode()
        } else if (Util.isAndroidMode()) {
            document.removeEventListener('keypress', this.handleAndroidKeypress)
        } else {
            clearInterval(this.barcodeInterval)
            if (this.$refs.tapInputCheckout) {
                this.$refs.tapInputCheckout.removeEventListener('keypress', this.handleKeypress)
            }
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        fillProductsBoxes: function () {
            this.cart = this.cart.filter(p => !p.isABox)
            let boxList = []
            let prodList = ProductController.getProdItem('unique')
            let modeEntrega = {
                levar: 'TGO'
            }
            for (let i = 0; i < this.cart.length; i++) {
                const prod = this.cart[i]
                if (prod.productAddProducts && prod.productAddProducts.length > 0) {
                    for (let j = 0; j < prod.productAddProducts.length; j++) {
                        const prodBox = prod.productAddProducts[j]
                        if (prodBox.isCharged === 'S' && prodBox.saleMode === modeEntrega[Util.getLocalVar('modoentrega')]) {
                            let addProdItem = { ...prodList.find(p => p.productCode === prodBox.addProductCode || p.subItemCode === prodBox.addProductCode) }
                            addProdItem.isABox = true
                            addProdItem.quantity = parseFloat(prodBox.addProductAmount) * prod.quantity
                            addProdItem = CartController.fixProdForCart(addProdItem)
                            boxList.push(addProdItem)
                        }
                    }
                }
            }
            this.cart = this.cart.concat(boxList)
            CartController.overrideCart(this.cart)
        },
        isModotap: function () {
            return Util.isTapMode()
        },
        isBalancaMode: function () {
            return Util.isBalancaMode()
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        useFixedServiceTax: function () {
            return Util.getLocalConfigs('fixedServiceTax')
        },
        hasServiceTax: function () {
            return (this.comandasAgregadas && this.comandasAgregadas[0] && this.comandasAgregadas[0].serviceTax !== null)
        },
        hasDiscount: function () {
            return this.cart.some(item => (Number(item.discount) || 0) > 0)
        },
        handleAndroidKeypress: function (event) {
            if (event.key === 'Enter') {
                this.comandaNumber = this.androidBarCodeComanda
                this.androidBarCodeComanda = ''
                this.accept()
            } else {
                this.androidBarCodeComanda += event.key
            }
        },
        closeComandaInputs: function () {
            // if (this.showInsertComanda) {
            // this.hide()
            // RfidController.stopListeningForRfid()
            this.showInsertComanda = false
            this.comandaNumber = ''
            this.androidBarCodeComanda = ''

            // if (this.isAndroidMode()) {
            this.androidVisible = false
            // document.getElementById('comandaNumber').innerText = this.comandaNumber
            this.$refs.comandaNumberCheckoutDiv.innerText = this.comandaNumber
            // }
            // }
        },
        closeAlterTaxInputs: async function () {
            if (this.showAlterTax) {
                this.hide()

                if (CartController.getComandasAgregadas()[0].serviceTax !== null) {
                    this.serviceTaxEdited = 0
                    await this.confirmServiceTax()
                }

                if (this.isAndroidMode()) {
                    this.androidVisible = false
                    document.getElementById('alterTax').innerText = this.serviceTaxEdited
                }

                this.serviceTaxDisabled = true
                this.showAlterTax = false
            }
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        addComandasParaPagamento: function () {
            this.showInsertComanda = true
            this.androidVisible = true
            this.layout = keyboardLayout.SIMPLE_NUMERIC
            // this.inputElement = document.getElementById('comandaNumber')
            this.inputElement = this.$refs.comandaNumberCheckoutDiv
            this.$refs.comandaNumberCheckoutDiv.innerText = this.comandaNumber
        },
        viewServiceTax: async function () {
            if (this.useFixedServiceTax() && this.hasServiceTax() && this.serviceTaxEditedBkp > 0) {
                this.controlsEnabled = false
                // se utilizar taxa fixa e automatica, ele so pode remover e adicionar o mesmo valor
                this.serviceTaxEdited = this.serviceTaxEditedBkp
                this.serviceTaxDisabled = false
                await this.confirmServiceTax()
                this.controlsEnabled = true
            } else {
                this.serviceTaxDisabled = false
                this.showAlterTax = true
                this.androidVisible = true
                this.layout = keyboardLayout.MONEY_NUMERIC_NO_CONFIRM
                this.inputElement = document.getElementById('alterTax')
                if (this.serviceTaxEdited) this.serviceTaxEdited = this.serviceTaxEdited.replace('R$', '').trim()
                document.getElementById('alterTax').innerText = this.serviceTaxEdited
            }
        },
        handleCardSerialNumber: function (cardSerialNumber) {
            this.comandaNumber = cardSerialNumber
            this.accept()
        },
        navigateToBalancaScreen: function () {
            this.$router.push('Balanca')
        },
        calculateTotalPrice: function () {
            return CartController.calculateTotalPrice(this.serviceTaxDisabled, true, true)
        },
        navigateToHome: function () {
            this.cart = this.cart.filter(p => !p.isABox)
            CartController.overrideCart(this.cart)
            this.waitToContinue = true
            SubgroupDiscountController.applyRemoveDiscounts(this.cart, true).then(() => {
                if (Util.isBalancaMode() && !this.hybridMode) {
                    this.$router.push('/balanca')
                } else if (Util.isTapMode()) {
                    Util.showConfirmationDialog(this.$modal, () => {
                        CartController.navigateToHome(this.$router)
                    }, this.getString('deseja_cancelar_pagamento'))
                } else {
                    CartController.navigateToHome(this.$router)
                }
                this.waitToContinue = false
            }).catch(() => {
                this.waitToContinue = true
            })
        },
        navigateToPayment: async function () {
            let usePager = Util.getLocalConfigs('usePager')
            let fixedServiceTax = Util.getLocalConfigs('fixedServiceTax')

            if (this.serviceTaxDisabled && this.hasServiceTax() && !fixedServiceTax) {
                // caso o cliente não tenha adicionado a taxa de serviço, remove a taxa na interface
                this.serviceTaxEdited = 0.001
                await this.confirmServiceTax()
            }
            if (usePager) {
                CartController.navigateToPager(this.$router)
            } else {
                // CartController.navigateToPayment(this.$router)
                if (this.idSolDigCons) {
                    CartController.navigateToConsumer(this.$router)
                } else {
                    CartController.navigateToPayment(this.$router)
                }
                // CartController.navigateToConsumer(this.$router)
            }
        },
        backToHome: function () {
            this.waitToContinue = true
            SubgroupDiscountController.applyRemoveDiscounts(this.cart, true).then(() => {
                this.waitToContinue = false
                this.$router.push('home')
            }).catch(() => {
                this.waitToContinue = true
            })
        },
        clearCart: function () {
            if (CartController.isCartEmpty()) {
                this.isModotap() ? this.$router.push('/') : this.$router.push('Home')
            } else {
                CartController.clearCart(this, '/')
            }
        },
        splitComanda: async function (saleCode) {
            await ProductController.splitComandas(saleCode)
            this.comandasAgregadas = CartController.getComandasAgregadas()
            this.cart = CartController.getCart()
            await this.refreshSubgroupDiscounts()
            this.serviceTaxEdited = this.formatMoney(CartController.getMainComandaAgregada().serviceTax)
            this.total = this.calculateTotalPrice()
        },
        enableControls: function () {
            this.controlsEnabled = true
        },
        disableControls: function () {
            this.controlsEnabled = false
        },
        acceptAndroid: async function () {
            this.androidVisible = false

            if (this.showAlterTax) {
                try {
                    this.serviceTaxEdited = document.getElementById('alterTax').innerText
                    Util.logComunication('Editando taxa de Serviço Manualmente', 'Taxa digitada:' + this.serviceTaxEdited, null)
                } catch (error) {
                    this.serviceTaxEdited = ''
                }
            } else {
                try {
                    this.comandaNumber = this.$refs.comandaNumberCheckoutDiv.innerText
                    if (this.comandaNumber === '') this.comandaNumber = this.$refs.tapInputCheckout.value
                } catch (error) {
                    this.comandaNumber = ''
                }
            }

            await this.accept()
        },
        accept: async function () {
            if (this.controlsEnabled) {
                this.disableControls()
                RfidController.stopListeningForRfid()
                if (this.comandaNumber.length > 0) {
                    // let savedComandaNumber = '' + this.comandaNumber
                    let canJoin = await ProductController.joinComandas(this.comandaNumber)
                    if (!canJoin) {
                        let mainComandaNumber = '' + CartController.getMainComandaAgregada().saleDescription
                        /* TODO: Precisei alterar a comanda que é passada pois não consegue ler mais comanda que foi unida, precisei resetar o carrinho */
                        await ProductController.getProductsFromComanda(mainComandaNumber, true)
                        if (CartController.getComandasAgregadas()[0].serviceTax !== null) {
                            CartController.getComandasAgregadas().forEach((c, k) => {
                                if (k !== 0) {
                                    CartController.getMainComandaAgregada().serviceTax += c.serviceTax
                                    c.serviceTax = 0
                                }
                            })
                        }
                        this.comandasAgregadas = CartController.getComandasAgregadas()
                    }
                    await this.refreshSubgroupDiscounts()
                    if (CartController.getComandasAgregadas()[0].serviceTax !== null) {
                        this.serviceTaxEdited = this.formatMoney(CartController.getMainComandaAgregada().serviceTax)
                    }
                } else if (this.serviceTaxEdited.length > 0 && CartController.getComandasAgregadas()[0].serviceTax !== null && this.showAlterTax) {
                    await this.confirmServiceTax()
                }

                this.closeComandaInputs()
                if (this.showAlterTax) {
                    this.showAlterTax = false
                    this.hide()
                }
                RfidController.listenForRfid(this.handleCardSerialNumber)
                this.enableControls()
            }
        },
        handleKeypress: function (event) {
            if (event.key === 'Enter' && this.controlsEnabled) {
                this.acceptAndroid()
            }
        },
        confirmServiceTax: async function () {
            this.serviceTaxEdited = this.formatNumber(this.serviceTaxEdited)
            let isInvalidValue = isNaN(parseFloat(this.serviceTaxEdited))
            if (isInvalidValue) this.serviceTaxEdited = 0

            if (this.comandasAgregadas[0].serviceTax !== this.serviceTaxEdited || (this.comandasAgregadas[0].serviceTax && this.serviceTaxDisabled) || this.automaticServiceTax) {
                if (this.serviceTaxEdited === 0 || this.serviceTaxEdited === '0' || this.serviceTaxEdited === '0.00' || this.serviceTaxEdited === 0.00 || this.serviceTaxDisabled) {
                    // É passado para a interface o valor de 0.001 quando o cliente opta por não pagar a taxa de serviço.
                    this.serviceTaxEdited = 0.001
                    this.serviceTaxDisabled = true
                    CartController.getMainComandaAgregada().serviceTax = 0.001
                }
                if (this.comandasAgregadas[0].serviceTax !== null) {
                    await SaleController.editServiceTax(this.comandasAgregadas[0].saleCode, this.serviceTaxEdited)
                    this.comandasAgregadas[0].serviceTax = parseFloat(this.serviceTaxEdited)
                }
                this.comandasAgregadas[0].totalValue = this.formatNumber(this.calculateTotalPrice())
                CartController.getComandasAgregadas().forEach((c, k) => {
                    if (k !== 0) {
                        c.serviceTax = 0
                    }
                })
                this.total = this.calculateTotalPrice()
                await this.refreshSubgroupDiscounts()
                this.serviceTaxEdited = this.formatMoney(CartController.getMainComandaAgregada().serviceTax)
                this.serviceTaxApplied = true
                CartController.getMainComandaAgregada().serviceTaxApplied = true
                this.$forceUpdate()
            }
        },
        removeServiceTax: function () {
            if (this.removTXServTap) {
                this.serviceTaxDisabled = true
                this.editServiceTax = 0
                this.confirmServiceTax()
            } else {
                Util.showInfoModal(this.getString('va_ao_caixa'))
            }
        },
        buildTextServiceTax () {
            let serviceTax = CartController.getMainComandaAgregada().serviceTax
            if (serviceTax && serviceTax > 0) {
                return this.getString('taxa_de_servico') + this.formatMoney(serviceTax)
            } else {
                return this.getString('taxa_de_servico') + 'R$ 0,00'
            }
        },

        calcSubgroupDiscount: function () {
            let totalDiscount = 0
            const cart = CartController.getCart()

            cart.forEach(item => {
                totalDiscount += (Number(item.discount) || 0)

                const children = item.productCombo || []
                children.forEach(child => {
                    totalDiscount += (Number(child.discount) || 0)
                })
            })

            return parseFloat(totalDiscount.toFixed(2))
        },
        calcPreDiscountSubtotal: function () {
            let total = 0
            const cart = CartController.getCart()

            cart.forEach(item => {
                total += (Number(item.unitValue || item.price || 0))
                const observations = item.observations || []
                observations.forEach(obs => {
                    const obsPrice = parseFloat(obs.price) || 0
                    const obsQty = Number(obs.quantity) || 1
                    if (obsPrice > 0) {
                        total += obsPrice * obsQty
                    }
                })

                // Valor dos filhos: child.unitValue é por unidade do PAI → multiplica por qty do pai
                const children = item.productCombo || []
                children.forEach(child => {
                    total += (Number(child.unitValue || child.price || 0))
                })
            })

            return parseFloat(total.toFixed(2))
        },
        refreshSubgroupDiscounts: async function () {
            this.waitToContinue = true
            if (this.cart.length === 0) return
            await SubgroupDiscountController.applyRemoveDiscounts(this.cart, false).then(() => {
                this.cart = [...CartController.getCart()]
                this.$forceUpdate()
                this.total = this.calculateTotalPrice()
                this.totalSubgroupDiscount = this.calcSubgroupDiscount()
                this.updateSubtotal()
                this.$forceUpdate()
                this.waitToContinue = false
            }).catch(() => {
                this.waitToContinue = true
            })
        },
        formatMoney: function (serviceTax) {
            return Util.formatMoney(serviceTax)
        },
        updateSubtotal: function () {
            // subtotal = valor bruto antes do desconto
            this.subtotal = Util.formatMoney(this.calcPreDiscountSubtotal())
        },
        formatNumber: function (value) {
            if (value && value.replace) {
                value = value.replace('R$', '').replace(',', '.')
                return value.trim()
            }
            return value
        },
        isGomLayout: function () {
            return Util.getLocalConfigs('utiliza_layout_gom')
        },
        applyMoneyRules: function (input) {
            if (!input) return ''

            input = this.clearZerosAtFirstInput(input)
            input = this.notAllowDuplicatedComma(input)
            input = this.notAllowExcedentDecimalCases(input)

            return input
        },
        clearZerosAtFirstInput: function (input) {
            if (input.length === 5 && input.slice(0, 4) === '0,00') {
                input = input.slice(4, 5)
            }
            return input
        },
        notAllowDuplicatedComma: function (input) {
            let firstComma = input.indexOf(',')
            let lastComma = input.lastIndexOf(',')
            if (firstComma !== -1 && firstComma !== lastComma) {
                input = input.slice(0, -1)
            }
            return input
        },
        notAllowExcedentDecimalCases: function (input) {
            let array = input.split(',')
            if (array.length > 1 && array[1].length > 2) {
                input = input.slice(0, -1)
            }
            return input
        },
        openAddProductModal: function (checkIfCanSeparateComandas = false) {
            RfidController.stopListeningForRfid()
            if (this.comandasAgregadas.length > 1 && checkIfCanSeparateComandas === false) {
                this.checkIfCanSeparateComandas()
                return
            }
            if (Util.isAndroidMode() && Util.isGertecSk210() && Util.isTapMode()) {
                clearInterval(this.gertecBarcodeInterval)
                window.GertecBarcodeReader.stopDecode()
            } else if (Util.isAndroidMode()) {
                document.removeEventListener('keypress', this.handleAndroidKeypress)
            } else {
                clearInterval(this.barcodeInterval)
            }
            this.showAddProductModal = true
        },
        checkIfCanSeparateComandas: function () {
            Util.showConfirmationDialog(this.$modal, () => this.openAddProductModal(true), this.getString('ao_adicionar_produtos_nao_sera_possivel_separar_as_comandas'), () => {})
        },
        closeAddProductModal: async function (reload = false) {
            // Se estiver fechando o modal de adicionar produto por conta de uma comanda pendente,
            // e o carrinho estiver vazio, volta para a tela inicial ao invés de reabrir o modal
            if (!reload && this.pendingComandaNumber && this.cart.length === 0) {
                this.showAddProductModal = false
                this.$router.push({ name: 'Home' })
                return
            }

            if (Util.isAndroidMode() && Util.isGertecSk210() && Util.isTapMode()) {
                setTimeout(() => {
                    window.GertecBarcodeReader.startDecode(this.ignoreQrCodeSk)
                }, 1000)

                this.gertecBarcodeInterval = setInterval(() => {
                    let readedCode = window.GertecBarcodeReader.getReadedCode()
                    if (readedCode) {
                        this.comandaNumber = readedCode
                        this.accept()
                    }
                }, 1000)
            } else if (Util.isAndroidMode()) {
                document.addEventListener('keypress', this.handleAndroidKeypress)
            } else {
                setTimeout(() => {
                    this.$refs.tapInputCheckout.addEventListener('keypress', this.handleKeypress)
                    this.barcodeInterval = setInterval(() => {
                        if (this.$refs.tapInputCheckout) {
                            this.$refs.tapInputCheckout.focus()
                        }
                    }, 500)
                }, 100)
            }

            RfidController.listenForRfid(this.handleCardSerialNumber)
            this.showAddProductModal = false
            if (reload) {
                this.waitToContinue = true
                this.comandasAgregadas = CartController.getComandasAgregadas()
                this.cart = CartController.getCart()
                this.serviceTaxEdited = this.formatMoney(CartController.getMainComandaAgregada().serviceTax)
                this.serviceTaxEditedBkp = CartController.getMainComandaAgregada().serviceTax
                if (this.automaticServiceTax && !this.pendingComandaNumber) {
                    this.serviceTaxDisabled = false
                    this.confirmServiceTax()
                }
            }
            await this.refreshSubgroupDiscounts()
        },
        openSuggestions: function () {
            // let cart = CartController.getCart()
            // if (cart.length === 0) return
            // this.lastIndexNotSuggested = cart.findLastIndex(item => !item.productSuggested)
            // if (this.lastIndexNotSuggested === -1) return
            // let cartItem = cart[this.lastIndexNotSuggested]
            // let productCode = cartItem.productCode
            // let groupCode = cartItem.categoryGroupCode
            // if (!productCode || !groupCode) return
            // this.suggestProductCode = productCode
            // this.suggestGroupCode = groupCode
            // SuggestionsController.resetCurrentGroupIndex()
            // SuggestionsController.markSuggestionsShown(this.lastIndexNotSuggested)
            // if (!SuggestionsController.hasSuggestions(groupCode, productCode)) return
            this.showSuggestions = false //  mudar aqui para forçar o re-render do componente e mostrar as sugestões corretas para o último item não sugerido
        },
        closeSuggestions: function () {
            this.showSuggestions = false
            this.suggestProductCode = null
            this.suggestGroupCode = null
        },
        handleSuggestion: function (prod) {
            this.closeSuggestions()
            let selectedProduct = JSON.parse(JSON.stringify(prod))
            this.$router.push({ name: 'ProductItem', params: selectedProduct })
        },
        navigateToGroup: function (groupName) {
            this.closeSuggestions()
            CartController.navigateToHome(this.$router)
            setTimeout(() => {
                eventModule.$emit('navigateToGroup', groupName)
            }, 300)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.checkout_container {
    display: grid;
    height: calc(100vh - 60px);
    grid-template-rows: 120px 1fr 120px;

    &.isModoTap:not(.gom_layout) {
        height: calc(100vh - 60px);
        grid-template-rows: 140px 1fr auto auto 100px;
    }

    &.gom_layout {
        height: calc(100vh - 60px);
        grid-template-rows: 120px 1fr auto 200px;
    }

    .header {
        display: flex;
        background-color: @header-color;
        margin-bottom: -3px;
        align-items: center;
        justify-content: space-between;
        padding-left: 2rem;
        padding-right: 2rem;

        span {
            font-size: 3rem;
            color: @white;
            font-weight: bold;

            &:last-child {
                margin: auto;
            }
        }

        .CircleButton {
            background: @white;
        }

        #login-button {
            animation: shakeShake 1s cubic-bezier(0.36, 0.07, 0.19, 0.97);
            animation-iteration-count: 1;
        }

        @keyframes shakeShake {
            0% {
                transform: rotateZ(4deg);
            }

            20% {
                transform: rotateZ(-4deg);
            }

            40% {
                transform: rotateZ(4deg);
            }

            60% {
                transform: rotateZ(-4deg);
            }

            80% {
                transform: rotateZ(4deg);
            }

            100% {
                transform: rotateZ(0deg);
            }
        }

        &.gom_layout {
            background-color: @white;

            span {
                color: rgb(99, 99, 99);
                text-transform: uppercase;
            }
        }
    }

    .remover_comanda_agregada,
    .numero_comanda_agregada {
        display: block;
        font-size: 2rem;
        font-weight: bold;
        margin-left: 10px;
    }

    .numero_comanda_agregada {
        color: @primary-color;
        margin-top: 2rem;
        margin-bottom: 15px;
    }

    .remover_comanda_agregada {
        font-size: 1.5rem;
        color: red;
    }

    .cart_itens {
        background-color: rgb(226, 225, 225);
        padding-left: 15px;
        padding-right: 15px;
        position: relative;
        display: block;
        max-width: calc(100vw - 30px);
        overflow: auto;
        padding-bottom: 0;

        .cart_itens_container.gom_layout {
            display: grid;
            grid-template-rows: 5fr 1fr;
            margin: 20px 20px;
            overflow: hidden;
            // height: calc(100% - 260px);
            height: auto;
            overflow: hidden;
            border-radius: 25px;
            background-color: @white;
            box-shadow: 2px 2px 5px 5px rgba(0, 0, 0, 0.1);

            // padding: 20px;
            .comanda-container {
                overflow: auto;
                overflow-x: hidden;
            }

            .cart_itens_footer {
                display: grid;
                grid-template-columns: 45% 55%;
                align-items: center;
                padding: 10px 15px;
                height: auto;

                // align-items: end;
                // border-top: solid 1px rgb(90, 90, 90);
                .footer_left_gom {
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    padding: 4px 10px;
                }

                .receipt-line {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    padding: 4px 0;

                    .receipt-label {
                        font-size: 2rem;
                        color: #5a5a5a;
                        margin-right: 16px;
                    }

                    .receipt-value {
                        font-size: 2rem;
                        color: #5a5a5a;
                    }
                }

                .discount-line {
                    .receipt-label,
                    .receipt-value { color: #4caf50; }
                }

                .total-line {
                    // border-top: 1px dashed #ccc;
                    margin-top: 4px;
                    padding-top: 8px;

                    .total-label {
                        font-size: 2rem;
                        font-weight: bold;
                        color: #222;
                    }

                    .total-value {
                        font-size: 2rem;
                        font-weight: bold;
                        color: #222;
                    }
                }

                .tax-service-gom {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    justify-content: flex-end;
                    background-color: @white;

                    .tax-service-buttons {
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        align-items: center;
                        margin: 10px 10px 25px 10px;

                        .control-buttons {
                            display: flex;
                            flex-direction: row;

                            button {
                                margin: 0 5px;
                            }
                        }

                        span {
                            font-size: 1.8rem;
                            padding-right: 10px;
                        }
                    }

                    .tap-buttons {
                        button {
                            box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
                        }
                    }
                }
            }
        }

        .cart_itens_container::-webkit-scrollbar-track {
            margin: 20px;
        }

        .to_payment {
            display: flex;
            justify-content: center;
            // flex-direction: row;
            justify-content: space-evenly;
            align-items: center;
            flex-wrap: wrap;
            min-height: 200px;
            button {
                box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
                min-width: 90%;
                margin: 5px;
            }
        }

        &.gom_layout {
            background-color: @white;
            display: grid;
            grid-template-rows: 1fr auto;
        }
    }

    .footer-checkout {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 2rem;
        padding-right: 2rem;
        background: white;

        .footer_left {
            display: flex;
            align-items: center;
            height: 100%;

            .footer_receipt {
                margin-right: 1.5rem;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
            }
        }

        #total_text {
            font-weight: bold !important;
            font-size: 1.9rem;
        }

        #total_price {
            font-size: 1.9rem;
            font-weight: bold;
        }

        &.androidMode {
            padding-left: 10px;
            padding-right: 10px;

            .footer_left {
                .footer_text {
                    margin-right: 0.5rem;
                }
            }

            #total_price {
                font-size: 1.7rem;
            }

            button {
                max-width: 280px;
            }
        }
        .btn-cart {
            min-width: min-content;
        }

        &.gom_layout {
            justify-content: space-around;
            button {
                width: 45%;
            }
        }
    }

    .overlay {
        z-index: 1;
        .full;
        content: '';
        background: black;
        opacity: .8;
    }

    .comandaInputContainer {
        position: fixed;
        left: 0;
        right: 0;
        top: calc(100vh - 80%);
        margin: 0 auto;
        background: white;
        padding: 50px 0;
        width: 850px;
        border-radius: 20px;
        z-index: 3;

        input {
            position: relative;
            margin: auto;
            display: block;
            font-size: 5rem;
        }
        .barcode-container {
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;
            margin: 0 30px;
            h2 {
                font-size: 2.4rem;
                font-weight: bold;
                margin-right: 10px;
                padding: 10px;
                text-align: center;
            }
            img {
                width: auto;
                height: 180px;
                object-fit: contain;
            }
        }

        .div-input-android {
            position: relative;
            margin: 30px;
            display: block;
            font-size: 5rem;
            height: 110px;
            background-color: white;
            color: black;
            border: 2px solid black;
            border-radius: 20px;
            padding: 0 20px;
            flex-grow: 1;
        }

        // .android-confirm-button {
        //     margin: 40px auto 0 auto;
        // }
        .confirm-button {
            margin: 40px 30px 0 30px;
            width: calc(100% - 60px);
        }

        h1 {
            position: relative;
            display: block;
            text-align: center;
            font-size: 45px;
            margin: 0 50px;
        }

        .money-container {
            display: flex;
            align-items: center;

            .money-symbol {
                font-size: 5rem;
                color: black;
                margin-left: 50px
            }
        }
    }

    .add-product-button {
        // position: absolute;
        // bottom: 330px;
        bottom: 130px;
        right: 20px;
        position: fixed;
        transition: all 1s ease-in-out;

        &.hidden {
            opacity: 0;
        }
    }

    #keyboard {
        .keyboard;
    }

    #android-keyboard {
        margin: 0 30px;
    }

    #tapInputCheckout {
        position: absolute;
        opacity: 0;
    }
}

.overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
}

.tax-service {
    height: 110px;
    background-color: rgba(211, 211, 211, 0.5);
    display: grid;
    grid-template-columns: 45% 14% 41%;
    padding: 0 30px;
    width: calc(100vw - 60px);

    span {
        font-size: 35px;
    }

    .btn-big {
        position: relative;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .tax-service-disabled {
        color: rgb(170, 170, 170);
    }

    &.noservicetax {
        grid-template-columns: 100%;

        .button-default.bottom {
            // margin: auto 0 auto auto;
            margin-left: 15px;
        }
    }

    .tap-buttons {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: right;
    }

    .tax-service-buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .discount-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 4px;
    }

    #discount_text {
        font-size: 2rem;
        color: #4CAF50;
        font-weight: bold;
        font-weight: 600;
    }

    #discount_price {
        font-size: 1.8rem;
        color: #4CAF50;
        font-weight: bold;
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .checkout_container {
        height: 100%;
        grid-template-rows: 50px 1fr auto 60px;

        &.gom_layout.isModoTap {
            grid-template-rows: 70px calc(100vh - 180px) 80px;
        }

        .add-product-button {
            position: fixed;
            background-color: #e2e1e100;
            bottom: 130px;
            right: 15px;
            transition: all 1s ease-in-out;

            button {
                margin-right: 0;
            }

            &.hidden {
                opacity: 0;
            }
        }

        .header {
            margin-bottom: 0;

            span {
                font-size: 30px;
            }

            &.gom_layout {
                span {
                    font-size: 28px;
                }
            }
        }

        .remover_comanda_agregada,
        .numero_comanda_agregada {
            font-size: 17px;
        }

        .numero_comanda_agregada {
            margin-top: 20px;
            margin-bottom: 15px;
        }

        .remover_comanda_agregada {
            font-size: 15px;
        }

        .comandaInputContainer {
            top: calc(100vh - 85%);
            padding: 20px 0;
            width: 350px;
            z-index: 2;

            .div-input-android {
                display: flex;
                align-items: center;
                margin: 20px 30px;
                font-size: 25px;
                height: 35px;
                border: 2px solid @black;
                border-radius: 5px;
                padding: 0 10px;
            }

            .barcode-container {
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                align-items: center;
                margin: 0 30px;
                h2 {
                    font-size: 1rem;
                    font-weight: bold;
                    margin-right: 5px;
                    padding: 5px;
                    text-align: center;
                }
                img {
                    width: auto;
                    height: 80px;
                    object-fit: contain;
                }
        }

            .confirm-button {
                margin: 10px 30px 0 30px;
                width: calc(100% - 60px);
            }

            h1 {
                font-size: 20px;
                margin: 0 20px;
            }

            .money-container {
                .money-symbol {
                    font-size: 25px;
                    margin-left: 30px;
                    margin-right: -15px;
                }
            }
        }

        .tax-service {
            height: 60px;
            width: calc(100vw - 20px);
            padding: 0 10px;
            // grid-template-columns: 45% 14% 41%;
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;
            gap: 10px;

            span {
                font-size: 12px;
            }
        }

        .footer-checkout {
            padding-left: 10px;
            padding-right: 10px;

            .footer_left {
                .footer_text {
                    margin-right: 0.5rem !important;
                }
            }

            #total_text {
                font-size: 15px !important;
            }

            #total_price {
                font-size: 20px !important;
            }

            .button-default {
                max-width: 200px;
                min-width: 180px;
            }
        }

        #android-keyboard {
            margin: 0;
            .small-screen-keyboard;
        }

        .cart_itens.gom_layout {
            grid-template-rows: 5fr 1fr;
            .cart_itens_container.gom_layout {
                margin: 5px 20px;
                height: auto;
                grid-template-rows: 75% 25%;
                border-radius: 15px;
                box-shadow: 1px 0px 4px 3px rgba(0, 0, 0, 0.1);
                .cart_itens_footer {
                    padding: 5px 5px 10px 5px;
                    grid-template-columns: 50% 50%;

                    .footer_text_gom {
                        font-size: 1rem;
                        font-weight: bold;
                        color: #5a5a5a;
                        padding: 10px;
                    }

                    .footer_left_gom {
                        .receipt-line {
                            .receipt-label,
                            .receipt-value {
                                font-size: 1rem;
                            }
                        }

                        .total-line {
                            .total-label,
                            .total-value {
                                font-size: 1rem;
                            }
                        }
                    }

                    .tax-service-gom {
                        .tax-service-buttons {
                            margin: 5px 5px 7px 5px;

                            span {
                                font-size: 16px;
                                text-align: center;
                            }
                        }

                        .tap-buttons {
                            button {
                                height: 2.5rem;
                            }
                        }
                    }
                }
            }

            .to_payment {
                min-height: 100px;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between !important;
                margin: 0 20px;
                button {
                    min-width: unset;
                    width: 45%;
                    height: 40px;
                    margin: 0;
                    box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.5);
                }
                &.center {
                    justify-content: center !important;
                }
            }
        }

        &.gom_layout {
            height: calc(100vh - 30px);
            grid-template-rows: 80px 1fr auto 80px;

            .header {
                span {
                    font-size: 28px;
                }
            }
        }
    }

    .tax-service {
        height: 60px;
        padding: 0 10px;
        width: calc(100vw - 20px);
        grid-template-columns: 40% 20% 40%;

        span {
            position: relative !important;
            font-size: 18px;
        }

        .btn-big {
            top: 0%;
            transform: translate(40%, 0%);
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    .checkout_container.gom_layout {
        height: calc(100vh - 60px);
        grid-template-rows: 120px 1fr auto 160px;
    }

    //@tablet
    .checkout_container {
        // grid-template-rows: 130px calc(100vh - 320px) 130px;
        grid-template-rows: 130px calc(100vh - 320px) 130px 100px;
        .header {
            span {
                font-size: 2.5rem;
            }
        }

        .comandaInputContainer {
            padding: 15px 0 40px 0;
            width: 85%;

            h1 {
                font-size: 1.5rem;
            }
            .barcode-container {
                margin: 0 30px;
                h2 {
                    font-size: 1.9rem;
                }
                img {
                    width: auto;
                    height: 130px;
                    object-fit: contain;
                }
            }
            .div-input-android {
                height: 90px;
                font-size: 4rem;
            }
        }

        .footer-checkout {
            padding-left: 10px;
            padding-right: 10px;

            .footer_left {
                .footer_text {
                    margin-right: 0.8rem;
                    justify-content: center;
                }
            }
            #total_text {
                font-size: 1.6rem;
            }
            #total_price {
                font-size: 1.6rem;
            }
            .button-default {
                max-width: unset;
                width: auto;
                min-width: 200px;
            }
        }

        #keyboard {
            .keyboard;
            max-width: 760px;
            font-size: 20px;
        }
    }

    // TAA normal (sem TAP) usa 3 linhas; evita espaço vazio/estouro no rodape.
    .checkout_container:not(.isModoTap):not(.gom_layout) {
        grid-template-rows: 120px calc(90vh - 240px) 120px !important;
    }

    .tax-service {
        // grid-template-columns: 41% 14% 45%;
        grid-template-columns: 45% 20% 35%;
        padding: 0 15px;
        width: calc(100vw - 30px);

        span {
            font-size: 25px;
        }
    }

    .cart_itens.gom_layout {
        .cart_itens_container.gom_layout {
            margin: 20px 20px;
            // height: calc(100% - 255px);
            height: auto;

            .cart_itens_footer {
                padding: 5px 5px 10px 5px;
                flex-direction: column;

                .footer_left_gom {
                    width: 100%;
                    padding: 4px 8px;

                    .receipt-line {
                        display: flex;
                        justify-content: space-evenly;
                        .receipt-label,
                        .receipt-value {
                            font-size: 1.6rem;
                        }
                    }

                    .total-line {
                        .total-label,
                        .total-value {
                            font-size: 1.8rem;
                        }
                    }
                }

                .tax-service-gom {
                    width: 100%;
                    justify-content: center;

                    .tax-service-buttons {
                        margin: 5px 5px 7px 5px;

                        span {
                            font-size: 16px;
                            text-align: center;
                        }
                    }

                    .tap-buttons {
                        button {
                            height: 3.5rem;
                        }
                    }
                }
            }
        }

        .to_payment {
            margin: 0 20px;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between !important;
            button {
                min-width: unset;
                margin: 0;
                width: 45%;
            }
            &.center {
                justify-content: center !important;
            }
        }
    }
}

@media (orientation: landscape) and (min-width: 699px) and (max-width: 1025px) {

    .checkout_container {
        .comandaInputContainer {
            .div-input-android{
                margin: 10px 50px 10px 30px !important;
            }
        }
    }
}

@media (orientation: landscape) and (min-width: 1000px) and (max-width: 1025px) {
    .checkout_container.isModoTap:not(.gom_layout) {
        .add-product-button {
            bottom: 175px;
            right: 20px;
            z-index: 0;
        }
    }
}

@media (orientation: landscape) {
    .checkout_container {
        display: grid;
        height: calc(100vh - 30px) !important;
        grid-template-rows: 9vh 1fr auto auto 10vh !important;
        &.gom_layout {
            height: calc(100vh - 30px);
            grid-template-rows: 9vh 1fr auto 10vh !important;
        }

        .header {
            background-color: @primary-color;

            .CircleButton {
                height: 50px;
                width: 50px;
            }
        }

        .cart_itens {
            padding-bottom: 20px;

            .cart_itens_container.gom_layout {
                grid-template-rows: 1fr auto;
                height: calc(100% - 200px);

                .cart_itens_footer {
                    padding: 10px 10px 20px 10px;
                    overflow-y: auto;

                    .footer_text_gom {
                        font-size: 2rem;
                        font-weight: bold;
                        color: #5a5a5a;
                        padding: 10px;
                    }
                }
            }

            .to_payment {
                flex-direction: column-reverse;

                button {
                    min-width: 450px;
                }
            }
        }

        .footer-checkout {
            #total_text {
                font-size: 2rem;
            }

            #total_price {
                font-size: 1.8rem;
            }

            &.gom_layout {
                button {
                    min-width: 45%;
                }
            }
        }

        .add-product-button {
            bottom: 210px;
        }

        .comandaInputContainer {
            z-index: 3;
            .div-input-android {
                margin: 50px 50px 50px 30px;
            }

            .barcode-container {
                margin: 0 45px;
            }
        }
    }

    .checkout_container.gom_layout {
        .header.gom_layout {
            span {
                color: @primary-dark;
                font-size: 2rem;
            }
        }

        .cart_itens.gom_layout {
            display: grid;
            grid-template-rows: 85% 15%;

            .cart_itens_container.gom_layout {
                margin: 0;
                height: 100%;
                border-radius: 10px;
                grid-template-rows: 1fr auto;
                border: solid 1px rgba(0, 0, 0, 0.4);

                .cart_itens_footer {
                    grid-template-columns: 60% 40%;
                    padding: 15px 10px 10px 10px;
                    align-items: start;

                    .footer_left_gom {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;
                        gap: 2px;
                    }

                    .tax-service-gom {
                        align-items: center;
                        border-radius: 10px;

                        .tax-service-buttons {
                            margin: 10px 10px 15px 10px;

                            span {
                                font-size: 1.3rem;
                                text-align: center;
                                padding-right: 0;
                            }

                            .control-buttons {
                                button {
                                    margin: 0 0 0 5px;
                                }
                            }
                        }

                        .tap-buttons {
                            button {
                                height: 4rem;
                            }
                        }
                    }
                }
            }

            .to_payment {
                min-height: 80px;
                flex-direction: row;

                button {
                    min-width: 350px;
                }
            }
        }
    }
}

@media (orientation: landscape) and (min-width: 1000px) and (max-width: 1025px) and (max-height: 768px) {
    .checkout_container.isModoTap.gom_layout {
        height: calc(100vh - 30px);
        grid-template-rows: 90px 1fr auto 100px !important;

        .header.gom_layout {
            span {
                font-size: 2.2rem;
            }
        }

        .cart_itens.gom_layout {
            grid-template-rows: 1fr auto;

            .cart_itens_container.gom_layout {
                margin: 6px 12px;
                height: auto;
                grid-template-rows: 1fr auto;

                .cart_itens_footer {
                    padding: 8px;

                    .receipt-line {
                        .receipt-label,
                        .receipt-value {
                            font-size: 1.4rem;
                        }
                    }

                    .total-line {
                        .total-label,
                        .total-value {
                            font-size: 1.6rem;
                        }
                    }

                    .tax-service-gom {
                        .tax-service-buttons {
                            margin: 6px;

                            span {
                                font-size: 1.1rem;
                            }
                        }

                        .tap-buttons {
                            button {
                                height: 3.2rem;
                            }
                        }
                    }
                }
            }

            .to_payment {
                min-height: 70px;
                margin: 0 12px 4px 12px;

                button {
                    min-width: 42%;
                    height: 3.2rem;
                }
            }
        }

        .footer-checkout.gom_layout {
            padding: 4px 16px 8px 16px;

            button {
                min-width: 42%;
                height: 3.2rem;
            }
        }
    }
}

@media (orientation: portrait) and (min-width: 700px) and (max-width: 800px) and (min-height: 1200px) {
    .checkout_container.isModoTap.gom_layout {
        height: calc(100vh - 60px);
        grid-template-rows: 100px 1fr auto 100px !important;

        .header.gom_layout {
            span {
                font-size: 2.2rem;
            }
        }

        .cart_itens.gom_layout {
            grid-template-rows: 1fr auto;

            .cart_itens_container.gom_layout {
                margin: 10px 14px;
                height: auto;
                grid-template-rows: 1fr auto;
            }

            .to_payment {
                min-height: 90px;
                margin: 0 14px 6px 14px;

                button {
                    min-width: 45%;
                    height: 3.3rem;
                }
            }
        }

        .footer-checkout.gom_layout {
            padding: 8px 16px;

            button {
                min-width: 45%;
                height: 3.2rem;
            }
        }
    }
}

// Protecao global: TAA normal nao deve herdar grids de TAP/GOM.
@media (max-width: 699px) {
    .checkout_container:not(.isModoTap):not(.gom_layout) {
        grid-template-rows: 50px 1fr auto 60px !important;
    }
}

@media (orientation: portrait) and (min-width: 699px) and (max-width: 1025px) {
    .checkout_container:not(.isModoTap):not(.gom_layout) {
        height: calc(100vh - 60px);
        grid-template-rows: 130px 1fr auto 100px !important;
    }
}
@media (orientation: portrait) and (width: 900px) and (max-width: 1600px) {
    .checkout_container:not(.isModoTap):not(.gom_layout) {
        grid-template-rows: 130px calc(90vh - 170px) auto 140px !important;
    }
}

@media (orientation: landscape) and (min-width: 699px) {
    .checkout_container:not(.isModoTap):not(.gom_layout) {
        grid-template-rows: 90px calc(90vh - 130px) auto 90px !important;
    }
}

@media (orientation: landscape) and (width: 1920px) and (height: 1080px) {
    .checkout_container:not(.isModoTap):not(.gom_layout) {
        grid-template-rows: 90px calc(90vh - 100px) auto 90px !important;
    }
}

@media (orientation: landscape) and (width: 1600px) and (height: 900px) {
    .checkout_container:not(.isModoTap):not(.gom_layout) {
        grid-template-rows: 90px calc(90vh - 120px) auto 90px !important;
    }
}
</style>
<style lang="less">
@import (reference) url("../assets/common.less");

.checkout_container.isModoTap {
    // grid-template-rows: 7vh 77vh 110px;  //7vh;
    grid-template-rows: 7vh 77vh 110px auto 7vh;

    &.gom_layout {
        // grid-template-rows: 100px calc(100vh - 235px) 100px !important;
        .cart_itens {
            padding-bottom: 0;
        }
    }

    &:not(.gom_layout) .cart_itens {
        position: relative;
        padding-bottom: 90px;
    }

    .button-default.bottom {
        right: 4rem;
        bottom: 1rem;

    }

    &:not(.gom_layout) .add-product-button {
        bottom: 180px;
        right: 20px;
        position: fixed;
        transition: all 1s ease-in-out;

        &.hidden {
            opacity: 0;
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .checkout_container.isModoTap {
        height: calc(100vh - 30px) !important;
        grid-template-rows: 50px 1fr 60px auto 60px !important;

        &:not(.gom_layout) .cart_itens {
            padding-bottom: 65px !important;
        }

        &:not(.gom_layout) .add-product-button {
            bottom: 155px;
            right: 15px;
        }
        &.gom_layout {
            grid-template-rows: 65px 1fr auto 80px !important;
        }
    }
}

@media (orientation: portrait) and (min-width: 1026px) {
    .checkout_container.isModoTap:not(.gom_layout) {
        .add-product-button {
            bottom: 280px;
            right: 35px;
        }
    }
}

@media (orientation: portrait) and (min-width: 1026px) and (max-width: 1100px) and (min-height: 1800px) and (max-height: 2000px) {
    // TAA normal (sem TAP) em 1080x1920: 3 linhas e folga para Poweredby.
    .checkout_container:not(.isModoTap):not(.gom_layout) {
        grid-template-rows: 180px calc(100vh - 420px) auto 180px !important;
    }
}

@media (orientation: portrait) and (min-width: 699px) and (max-width: 1025px) {
    .checkout_container.isModoTap:not(.gom_layout) {
        height: calc(100vh - 60px);
        grid-template-rows: 120px 1fr 90px auto 85px !important;

        .cart_itens {
            padding-bottom: 100px;
        }

        .tax-service {
            height: 100%;
            padding: 0 12px;
            width: calc(100vw - 24px);
        }

        .footer-checkout {
            padding-bottom: 0;
        }

        .add-product-button {
            bottom: 250px;
            right: 20px;
            z-index: 0;
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) and (orientation: landscape) {

    //@tablet landscape (ex: 1024x768) — layout normal (não GOM)
    .checkout_container:not(.gom_layout) {
        grid-template-rows: 120px calc(90vh - 245px) 95px 85px !important;
    }

    .checkout_container.isModoTap:not(.gom_layout) {
        grid-template-rows: 120px calc(90vh - 300px) 85px 110px !important;

        .tax-service {
            height: 85px;
        }

        .footer-checkout {
            padding-bottom: 30px;
        }

        .add-product-button {
            bottom: 210px;
            right: 20px;
        }
    }

    //@tablet landscape (ex: 1024x768) — TAP layout GOM
    // grid encerra em 100vh-30px para não sobrepor a barra TEKNISA (30px fixed)
}

@media (orientation: landscape) and (min-width: 1000px) and (max-width: 1025px) and (max-height: 768px) {
    .checkout_container.isModoTap:not(.gom_layout) {
        height: calc(100vh - 30px) !important;
        grid-template-rows: 110px 1fr auto auto 70px !important;

        .cart_itens {
            padding-bottom: 80px;
        }

        .tax-service {
            height: 70px;
            padding: 0 12px;
            width: calc(100vw - 24px);

            span {
                font-size: 18px;
            }
        }

        .footer-checkout {
            padding-bottom: 0;
        }

        .add-product-button {
            bottom: 200px;
            right: 20px;
            z-index: 0;
        }
    }
}

@media (orientation: landscape) and (min-width: 1026px) {
    .checkout_container.isModoTap {
        display: grid;
        grid-template-rows: 9vh 65vh 10vh auto 12vh;

        .header {
            background-color: @primary-color;

            span {
                font-size: 2.5rem;
            }

            .CircleButton {
                height: 50px;
                width: 50px;
            }
        }

        .remover_comanda_agregada,
        .numero_comanda_agregada {
            font-size: 1.5rem;
        }

        .numero_comanda_agregada {
            margin-top: 1.5rem;
        }

        .remover_comanda_agregada {
            font-size: 1.3rem;
        }

        .cart_itens {
            max-width: unset;
            padding-bottom: 20px;

            .cart_itens_container.gom_layout {
                grid-template-rows: 1fr auto;
                margin: 50px 20px;
                overflow: auto;
                height: calc(100% - 350px);

                .cart_itens_footer {
                    align-items: start;
                    padding: 10px 10px 20px 10px;
                }

                .footer_left_gom {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }
            }
        }

        .footer-checkout {
            .footer_left {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .footer_text {
                    margin-right: 1.5rem;
                    display: flex;
                    align-items: center;
                    flex-direction: row;
                    flex-wrap: nowrap;

                    span {
                        margin-right: 10px;
                    }
                }

                .discount-line {
                    display: flex;
                    align-items: center;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    margin-top: 2px;

                    #discount_text {
                        font-size: 2rem;
                        margin-right: 10px;
                        font-weight: bold;
                        color: #4caf50;
                    }

                    #discount_price {
                        font-size: 1.8rem;
                        font-weight: bold;
                        color: #4caf50;
                    }
                }
            }

            #total_text {
                font-size: 2rem;
            }

            #total_price {
                font-size: 1.8rem;
                font-weight: bold;
            }
        }

        .overlay {
            z-index: 1;
        }

        .comandaInputContainer {
            z-index: 2;
            top: calc(100vh - 85%);
            padding: 30px 0;
            width: 750px;

            .div-input-android {
                margin: 30px 45px;
                font-size: 3rem;
                height: 60px;
            }

            .barcode-container {
                margin: 0 45px;

                h2 {
                    font-size: 2.3rem;
                }

                img {
                    height: 160px;
                }
            }

            .confirm-button {
                margin: 10px auto 0 auto;
                width: calc(100% - 60px);
                max-width: 460px;
            }

            h1 {
                font-size: 27px;
            }

            .money-container {
                .money-symbol {
                    font-size: 3rem;
                }
            }
        }

        .add-product-button {
            bottom: calc(180px + 4vh);
            right: 35px;

            &.hidden {
                opacity: 0;
            }
        }

        .tax-service {
            grid-template-columns: 30% 13% 57%;
            padding: 0 15px;
            width: unset;
            height: auto;

            span {
                font-size: 20px;
            }

            &.noservicetax {
                grid-template-columns: auto;
                justify-content: end;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Checkout.vue